import React from 'react';
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import { Col, Row } from "reactstrap";

import FilesCustom from 'components/FilesCustom';


export default function FilesFrag(props) {
    const { data, formManager, modelFctManager, bindPropResult, parentProps, isConfiguration, childShouldRerender, parentDisabled } = props;

    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };
    const { register, getValues, setValue, errors, control } = formManager;

    const [rerender, setRerender] = React.useState(false);

    React.useEffect(() => {
        if (data.onActionEvents && data.onActionEvents["onLoad"]) {
            data.onActionEvents["onLoad"].forEach((args, index) => {
                modelFctManager.onActionRequired(data.name, args, data, args.trigger === "setValue" ? { value: (data.hasOwnProperty("defaultValue") ? data.defaultValue : "") } : null).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: "Echec",
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        if ((!data.children || data.children.length === 0) && modelFctManager?.finalizeProcess) modelFctManager.finalizeProcess(data, parentProps);
    }, []);
    React.useEffect(() => {
        data.childRendered = 0;
        if (childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);
    }, [props]);
    if (!childShouldRerender && modelFctManager?.commonRenderProc) modelFctManager.commonRenderProc(data);

    data.functionManager = {};
    data.functionManager.getParentProps = () => { return parentProps; };
    //data.functionManager.rerender = () => { setShouldRender(!shouldRender) };


    var filesSite = modelFctManager.appProps?.getSite();

    var defaultValue = data.defaultValue || [];
    register(bindPropResult, {
        value: defaultValue
    });

    var currentFiles = getValues(bindPropResult) || [];
    console.debug();

    return <Col><FilesCustom className="generateDlg-files" title={t("gal_attachedFiles")} bindID={(filesSite?.idSite || 0)} checkRights={modelFctManager.checkRights} fileTypeID={data.argumentsObj?.fileTypeID || "SITE"} src={null} srcName={""}
        files={currentFiles} setFiles={(compFiles) => {
            console.debug(compFiles.length);
            console.debug(compFiles);
            setValue(bindPropResult, compFiles);
            setRerender(!rerender);

        }} altFilesTypes="../api/site/GetSiteFilesType" altUploadFilesUrl="../api/site/UploadSiteFiles" accept={data.argumentsObj?.accept || { "text/csv": [".csv"] }} noChooseTypes={true} minFiles={data.argumentsObj?.minFiles || 2} uploadAutoClose={false} resetAfterUpload={false}
        noUploads={data.argumentsObj?.noUploads} onlyUpload={!data.argumentsObj?.fullFiles} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={data.argumentsObj?.fileType || "CTG"} maxFiles={data.argumentsObj?.maxFiles || 2} /></Col>;

}